import clone from "lodash/cloneDeep";
import mapValues from "lodash/mapValues";
import { Documents } from "@firefly/fly-design-core";
export function isColor(color) {
  return typeof color === "string" && (color.length === 6 || color.length === 8 || color.startsWith("#") && (color.length === 4 || color.length === 7 || color.length === 9));
}
export function color2hex(color) {
  if (!isColor(color)) {
    return undefined;
  }
  if (color !== null && color !== void 0 && color.startsWith("#")) {
    if (color.length === 4) {
      var h1 = color.substring(1, 2);
      var h2 = color.substring(2, 3);
      var h3 = color.substring(3, 4);
      return "#".concat(h1).concat(h1).concat(h2).concat(h2).concat(h3).concat(h3);
    }
    /**
     * 对颜色进行升级
     */
    function color2hex(color) {
      var h1 = color.substring(0, 2);
      var h2 = color.substring(2, 4);
      var h3 = color.substring(4, 6);
      if (color.length === 6) {
        return "#".concat(h1).concat(h2).concat(h3);
      } else {
        var h4 = color.substring(6, 8);
        return "#".concat(h2).concat(h3).concat(h4).concat(h1);
        // return `rgba(${h2}, ${h3}, ${h4}, ${h1 / 255})`;
      }
    }
    return color2hex(color.substring(1));
  } else {
    throw new Error("unknown color format: ".concat(color, " "));
  }
}
export default function upgrade(input) {
  var upgradeElementVisitor = {
    enter: function enter(element) {
      var as = element.as,
        properties = element.properties;
      delete properties.identifier;
      switch (as) {
        case "Text":
          {
            var style = properties.style;
            properties.style.color = color2hex(style.color);
            break;
          }
        case "Graphic":
          {
            var palette = properties.palette;
            properties.palette = mapValues(palette, function (v) {
              return color2hex(v);
            });
            break;
          }
        case "GridGraphic":
          {
            var paths = properties.paths;
            paths.forEach(function (path) {
              var _path$stroke;
              if (path.fill) {
                if (typeof path.fill === 'string') {
                  path.fill = color2hex(path.fill);
                }
                if (path.fill.type === 'color') {
                  path.fill.color = color2hex(path.fill);
                }
              }
              if ((_path$stroke = path.stroke) !== null && _path$stroke !== void 0 && _path$stroke.fill) {
                if (path.stroke.fill.type === 'color') {
                  path.stroke.fill.color = color2hex(path.fill);
                }
              }
            });
          }
      }
    }
  };
  var document = clone(input);
  Documents.visit(document, {
    background: function background(_background) {
      if (_background) {
        _background.color = color2hex(_background.color);
      }
      return _background;
    },
    element: upgradeElementVisitor
  });
  document.version = "1.2";
  return document;
}